namespace $ {

	export const $shm_hitalama_lib_tg_toHTML = require( '../shm/hitalama/lib/bundle/_index.js' ).toHTML
	export const $shm_hitalama_lib_tg_toMarkdownV2 = require( '../shm/hitalama/lib/bundle/_index.js' ).toMarkdownV2

}
